import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly supported = ['fr', 'en'];
  private readonly fallback = 'fr';

  constructor(private translate: TranslateService) {}

  init(): void {
    const stored = localStorage.getItem('lang');
    const browser = this.translate.getBrowserLang();

    const lang = stored && this.supported.includes(stored)
      ? stored
      : this.supported.includes(browser ?? '')
        ? browser!
        : this.fallback;

    this.translate.setDefaultLang(this.fallback);
    this.translate.use(lang);
  }

  setLang(lang: string): void {
    if (!this.supported.includes(lang)) return;
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
  }
}
